<template>
	<main class="new-home">
		<home-hero />
		<event-calendar
			:events="currentAndNextYearEvents"
			:loading="loading"
		/>
	</main>
</template>

<script>
import EventService from '../../services/EventService';
import HomeHero from './HomeHero.vue';
import EventCalendar from './EventCalendar.vue';

export default {
	components: {
		HomeHero,
		EventCalendar,
	},
	data() {
		return {
			eventService: new EventService(),
			events: [],
			loading: false,
		};
	},
	computed: {
		currentAndNextYearEvents() {
			const currentYear = new Date().getFullYear();
			const visibleYears = [currentYear, currentYear + 1];

			return this.events.filter(event => visibleYears.indexOf(this.eventYear(event)) !== -1);
		},
	},
	mounted() {
		this.fetchEvents();
	},
	methods: {
		fetchEvents() {
			this.loading = true;
			this.eventService.getAllAvaliable().then(res => {
				const events = (res.data || []).sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

				this.events = events;
				this.loading = false;
			}).catch(() => {
				this.events = [];
				this.loading = false;
			});
		},
		eventYear(event) {
			if (!event || !event.startDate) return null;
			const year = parseInt(`${event.startDate}`.split('-')[0], 10);
			return Number.isNaN(year) ? null : year;
		},
	},
};
</script>

<style scoped lang="scss">
.new-home {
	background: #f5f5f5;
	color: #4f4f4f;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue